import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=3ca1cc3a&scoped=true&"
import script from "./TheFooter.js?vue&type=script&lang=js&"
export * from "./TheFooter.js?vue&type=script&lang=js&"
import style0 from "./TheFooter.scss?vue&type=style&index=0&id=3ca1cc3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca1cc3a",
  null
  
)

export default component.exports